import React from "react";
import "../assets/styles/style.css";

const Footer = () => {
  return (
    <footer className="footer-bottom">
      <p>© {new Date().getFullYear()} Arise. All rights reserved.</p>
    </footer>
  );
};

export default Footer;
